import { Link, useRouterState } from '@tanstack/react-router';
import {
  BarChart3,
  BookOpen,
  Cog,
  FileSpreadsheet,
  History,
  LayoutDashboard,
  Receipt,
  ScrollText,
  Target,
  Wallet,
} from 'lucide-react';
import { cn } from '@/lib/cn';

export interface NavItem {
  readonly label: string;
  readonly to: string;
  readonly icon: typeof LayoutDashboard;
}

export const NAV: readonly NavItem[] = [
  { label: 'Dashboard', to: '/', icon: LayoutDashboard },
  { label: 'Positions', to: '/positions', icon: Wallet },
  { label: 'Historique', to: '/valuations', icon: History },
  { label: 'Stratégie', to: '/strategy', icon: Target },
  { label: 'Transactions', to: '/transactions', icon: Receipt },
  { label: 'Comptabilité', to: '/accounting', icon: BarChart3 },
  { label: 'Plan de comptes', to: '/chart-of-accounts', icon: BookOpen },
  { label: 'Périodes', to: '/periods', icon: FileSpreadsheet },
  { label: 'Journal d’audit', to: '/audit-log', icon: ScrollText },
  { label: 'Paramètres', to: '/settings', icon: Cog },
];

export function Sidebar(): JSX.Element {
  const { location } = useRouterState();
  return (
    <aside className="hidden w-60 shrink-0 border-r bg-card/40 md:flex md:flex-col">
      <div className="flex h-14 items-center border-b px-4">
        <span className="text-base font-semibold tracking-tight">alafec</span>
        <span className="ml-2 text-xs text-muted-foreground">v0</span>
      </div>
      <nav className="flex flex-col gap-1 p-3">
        {NAV.map((item) => {
          const Icon = item.icon;
          const active =
            item.to === '/' ? location.pathname === '/' : location.pathname.startsWith(item.to);
          return (
            <Link
              key={item.to}
              to={item.to}
              className={cn(
                'flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                active
                  ? 'bg-secondary text-secondary-foreground'
                  : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground',
              )}
            >
              <Icon className="h-4 w-4" />
              {item.label}
            </Link>
          );
        })}
      </nav>
    </aside>
  );
}
